// Close a modal from its backdrop ONLY when the press started on the backdrop.
//
// A plain onClick on the backdrop also fires when the press starts INSIDE the
// dialog (selecting text, dragging a slider, resizing a textarea) and the
// button is released outside it — the browser reports that click on the common
// ancestor, the backdrop, and the dialog closed mid-selection. Every modal
// backdrop uses this helper so the bug cannot come back one modal at a time:
//   <div style={overlay} {...backdropClose(onClose)}>
export const backdropClose = (onClose) => ({
  onMouseDown: (e) => { if (e.target === e.currentTarget) onClose(); },
});
